import { Navbar , Nav, Container,NavDropdown} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useState, useEffect, } from 'react'
import './Navbar.css';
import logo from "./Assets/logo.png";



function Navigation() {



  const [show, setShow] = useState(false);
  const [button,setButton] = useState(true);


   

  const showButton = () =>{
    if(window.innerWidth <= 960){
      setButton(false);
      setNavbar(true);
    }
    else{
      setButton(true);
    }
  }
  
  const showDropdown = (e)=>{
      setShow(!show);
  }
  const hideDropdown = e => {
      setShow(false);
  }

const [navbar,setNavbar] = useState(false);

  const changeBackground = () =>{
    if(button){
    if(window.scrollY>=80){
      setNavbar(true);
    }
    else{
      setNavbar(false);
    }
  }
  else{
    setNavbar(true);
  }
  }
  useEffect(()=>{
    showButton();
  },[]);

  window.addEventListener('resize',showButton);

window.addEventListener('scroll',changeBackground);

return(
<Navbar  style={{backgroundColor:'white',transition:'1000ms',height:button?'12vh':'',paddingRight:10,paddingLeft:10,paddingTop:20,paddingBottom:20}} collapseOnSelect expand="lg" variant="light" fixed='top'>
  <Navbar.Brand  href="/">  <img  style={{height:25,marginLeft:15}} src={logo}></img></Navbar.Brand>
  <Navbar.Toggle aria-controls="responsie-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-end" style={{paddingRight:50}}>

    <Nav   style={{}}>
    <Nav.Link className='navLink'  style={{marginRight:25}} href="/">Home</Nav.Link>
    <Nav.Link className='navLink'  style={{marginRight:25}} href="/projects">Projects</Nav.Link>
      <Nav.Link className='navLink'  style={{marginRight:25}} href="/about">About Us</Nav.Link>
      <Nav.Link className='navLink' eventKey={2} href="/contact">
        Contact Us
      </Nav.Link>
    </Nav>
  </Navbar.Collapse>
</Navbar>
);
} 

export default Navigation;